import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'wouter';
import { v4 as uuidv4 } from 'uuid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import TransferTable from './TransfersTable';
import transferSelector from '../transferSelector';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import transformer from '../../common/helpers/transformer';
import type { AppDispatch } from '../../store';
import { addTransfer, loadTransfers } from '../transfersReducer';

function Transfers() {
  const dispatch: AppDispatch = useDispatch();
  const [location, setLocation] = useLocation();

  const transfers = useSelector(transferSelector.getTransfers);
  const status = useSelector(transferSelector.getStatus);

  const [searchValue, setSearchValue] = React.useState('');
  const [showFinishedTransfers, setShowFinishedTransfers] = React.useState(false);

  React.useEffect(() => {
    dispatch(loadTransfers());
  }, []);

  return (
    <Stack px={3} py={4} spacing={2} height='100%' overflow='hidden'>
      <Stack direction='row' alignItems='center' width='100%'>
        <Typography fontSize='1.5rem'>Übergabe </Typography>
        <Button
          sx={{ margin: '0 16px' }}
          aria-label='Klientin hinzufügen'
          startIcon={<AddCircleIcon />}
          variant='contained'
          onClick={async () => {
            const id = uuidv4();
            const payload = await transformer.fromObjectToBase64WithEncryption({ state: false });

            await dispatch(addTransfer({ id, payload }));
            await dispatch(loadTransfers());

            setLocation(`${location}/${id}`);
          }}
        >
          Neue Übergabe
        </Button>
        <Stack direction='row' alignItems='flex-end' ml='auto' gap={4}>
          <FormControlLabel
            control={
              <Checkbox
                size='small'
                checked={showFinishedTransfers}
                onChange={() => {
                  setShowFinishedTransfers(!showFinishedTransfers);
                }}
              />
            }
            label='Abgeschlossene anzeigen'
          />
          <TextField
            label='Suche'
            type='search'
            variant='standard'
            sx={{ width: '300px' }}
            onChange={(event) => setSearchValue(event.target.value)}
          />
        </Stack>
      </Stack>

      {status === 'loading' ? (
        <LoadingIndicator />
      ) : (
        <TransferTable searchValue={searchValue} showFinishedTransfers={showFinishedTransfers} transfers={transfers} />
      )}
    </Stack>
  );
}

export default Transfers;
